// extracted by mini-css-extract-plugin
export default {"bml-banner":"bml-banner__LC3i7","mb-pagination-bullet":"mb-pagination-bullet__CIMXq","mb-pagination-bullet-active":"mb-pagination-bullet-active__wmJna"};